import React, { useCallback } from "react";
import SubmenuItems from "../../components/Header/SubmenuItems";
import { HiveIcons } from "../../assets/icons";
import SearchBox from "../../components/Common/SearchBox";
import { useTableSearch } from "../../helpers/hooks";
import FilterBase from "components/Common/FilterBase";
import TableFilters from "components/Common/TableFilters";
import {
  ALERT_CATEGORY,
  THREAT_LEVEL_OPTIONS,
  YES_NO_OPTIONS,
} from "constants/enums";
import { getParameterByName, updateURLParameter } from "helpers/utils";
import { TextField } from "@material-ui/core";
import { TextFilter } from "components/Common/TextFilter";
import { EntityType } from "store/@core/entityType";
import { OptionsFilterPopoverDialog } from "components/Common/OptionsFilterPopoverDialog";
import { RangeFilter } from "components/Common/RangeFilter";
import { DateRangeFilter } from "components/Common/DateRangeFilter";

function LastUpdatedDate({ locationSearch, setLocationSearch }) {
  const handleChange = useCallback(
    (value) => {
      const safeValue = value.target.value.toString();
      const searchDate = updateURLParameter(
        locationSearch,
        "lastUpdatedAt",
        safeValue
      );
      setLocationSearch(searchDate);
    },
    [locationSearch, setLocationSearch]
  );

  return (
    <TextField
      variant="standard"
      margin={"normal"}
      type="date"
      fullWidth
      sx={{ width: "300px" }}
      value={getParameterByName("lastUpdatedAt", locationSearch) || ""}
      onChange={handleChange}
      label={"Last Updated Date"}
      color={"primary"}
      InputLabelProps={{
        shrink: true,
      }}
    />
  );
}

const filterOptions = [
  {
    customEl: (locationSearch, setLocationSearch) => (
      <RangeFilter
        locationSearch={locationSearch}
        setLocationSearch={setLocationSearch}
        fromParam={"fromAlertId"}
        toParam={"toAlertId"}
        fromParamLabel={"From Alert Id"}
        toParamLabel={"To Alert Id"}
      />
    ),
  },

  {
    label: "Threat Category",
    value: "category",
    multiple: true,
    options: ALERT_CATEGORY,
  },
  {
    customEl: (locationSearch, setLocationSearch, handleChange) => (
      <TextFilter
        locationSearch={locationSearch}
        setLocationSearch={setLocationSearch}
        filterKey="shortName"
        label="Short Name"
        fullWidth
      />
    ),
  },
  {
    customEl: (locationSearch, setLocationSearch) => (
      <OptionsFilterPopoverDialog
        locationSearch={locationSearch}
        setLocationSearch={setLocationSearch}
        paramButtonTitle={"CVEs"}
        paramDialogTitle={"CVEs"}
        paramName={"cves"}
        entityType={EntityType.CveDefinition}
        hasMultipleParamName={"hasMultipleCVEs"}
        nameProp={"cve"}
        valueProp={"cve"}
      />
    ),
  },
  {
    customEl: (locationSearch, setLocationSearch, handleChange) => (
      <TextFilter
        locationSearch={locationSearch}
        setLocationSearch={setLocationSearch}
        filterKey="attacks"
        label="Attacks"
        fullWidth
      />
    ),
  },
  {
    customEl: (locationSearch, setLocationSearch, handleChange) => (
      <TextFilter
        locationSearch={locationSearch}
        setLocationSearch={setLocationSearch}
        filterKey="actors"
        label="Actors"
        fullWidth
      />
    ),
  },
  {
    label: "CISA",
    value: "cisaAvailability",
    options: YES_NO_OPTIONS,
  },
  {
    customEl: (locationSearch, setLocationSearch) => (
      <LastUpdatedDate
        locationSearch={locationSearch}
        setLocationSearch={setLocationSearch}
      />
    ),
  },
  {
    customEl: (locationSearch, setLocationSearch) => (
      <DateRangeFilter
        locationSearch={locationSearch}
        setLocationSearch={setLocationSearch}
        fromFilterKey={"fromUpdatedAt"}
        toFilterKey={"toUpdatedAt"}
        fromLabel={"From Last Updated At"}
        toLabel={"To Last Updated At"}
      />
    ),
  },

  {
    label: "Threat Level",
    value: "threatLevel",
    options: THREAT_LEVEL_OPTIONS,
  },
];

const AlertSubheader = (props) => {
  const [query, handleChange, syncQuery] = useTableSearch();

  const menuItems = [
    {
      pushRight: true,
      customEl: (
        <SearchBox
          query={query}
          handleChange={handleChange}
          syncQuery={syncQuery}
        />
      ),
    },
    {
      customEl: (
        <FilterBase>
          <TableFilters filterOptions={filterOptions} />
        </FilterBase>
      ),
    },
    {
      divider: true,
    },
    {
      title: "New alert",
      icon: <HiveIcons.AddOutlined />,
      onClick: props.handleCreateNew,
    },
    {
      title: "Customize View",
      onClick: props.openSettings,
    },
  ];

  return <SubmenuItems items={menuItems} />;
};

export default AlertSubheader;
